module.exports = __webpack_public_path__ + "img/BX.7c5ea0fd.png";